/**
 * The board's step of a signed-in preview's handshake, resumed after sign-in. A
 * preview sends a signed-out browser to `/api/previews/<id>/auth`, which sends it
 * here as `/?preview_auth=<id>&next=<path>`; once the app knows who is looking it
 * goes back to that route, which now finds a session and returns the browser to
 * the preview (see `services/previews.ts`).
 */
export function previewAuthResumeUrl(search: string): string | null {
  const params = new URLSearchParams(search);
  const id = params.get("preview_auth");
  if (!id || !/^prv_[a-z0-9]+$/.test(id)) return null;
  const next = params.get("next") ?? "/";
  return `/api/previews/${id}/auth?next=${encodeURIComponent(next.startsWith("/") ? next : "/")}`;
}

/** Leaves for the preview's sign-in step when the address asks for it; true when it did. */
export function resumePreviewSignIn(): boolean {
  const url = previewAuthResumeUrl(window.location.search);
  if (!url) return false;
  window.location.replace(url);
  return true;
}
